import React, { useEffect, useState, memo } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { Popover } from 'antd'
import moment from 'moment'
import LazyLoad from 'react-lazyload'
import styles from './index.scss'
import imgErweimaApp from '~/img/share/erweima-app.png'
import { preloadImg } from '$utils'
import { getSoldCars } from './service'


const DetailSoldCars = ({ carId }) => {
  const [similarCars, setSimilarCars] = useState([])
  const getSoldCarsFuc = async () => {
    try {
      const result = await getSoldCars({ cid: carId })
      result?.data && setSimilarCars([...result?.data?.slice(0, 4)])
    } catch (error) {
      if (error.status === 200) {
        const result = error.data
        result?.data && setSimilarCars([...result?.data?.slice(0, 4)])
      }
    }
  }
  useEffect(() => { getSoldCarsFuc(); preloadImg([imgErweimaApp]) }, [])

  // const miniSuffix = '?imageView/4/w/80/h/53'
  const erweimaAppPopover = (
    <Link href="/other/appdown">
      <a>
        <img
          className={styles['img-erweima']}
          src={imgErweimaApp}
          alt="erweima"
        />
      </a>
    </Link>
  )

  const similarCarsJsx = (
    <div
      className="r-detail-similar-sold"
      data-exposure="car-detail_dealhistory_display"
      onMouseEnter={() => {
        global.$rbl.push('car-detail_dealhistory-checkmore_hover')
      }}
    >
      <h2 className="r-detail-similar-sold__title">
        类似车辆成交
        <Popover placement="bottom" content={erweimaAppPopover} trigger="hover">
          <span onMouseEnter={() => {
            global.$rbl.push('car-detail_dealhistory-checkmore_hover')
          }}
          >下载APP查看更多<i className="iconfont icon-jiantou" />
          </span>
        </Popover>
      </h2>
      <ul className="r-detail-similar-sold__main clearfix">
        {similarCars && similarCars.map((car, index) => (
          <a href={`/buy/detail/${car.id}`} key={index}>
            <li className="item" key={index}>
              <div className="item-img">
                <LazyLoad>
                  <img src={`//${car.search_image_url}`} alt="类似车源详情图" />
                </LazyLoad>
              </div>
              <div className="item-detail">
                <p className="item-detail__title">{car.title}</p>
                <p className="item-detail__desc">{moment(car.licensed_date).format('YYYY-MM-DD')}上牌/{car.mileage}万公里/{car.city}</p>
              </div>
              <div className="item-other">
                <p className="item-other__price">{Number(car.sold_price).toFixed(2)}万</p>
                <p className="item-other__date">{moment(car.sold_date).format('YYYY-MM-DD')}成交</p>
              </div>
              <div className="item-tag" />
              <div className="item-tag-txt">已成交</div>
            </li>
          </a>
        ))}
      </ul>
    </div>
  )
  return similarCars?.length > 3 ? similarCarsJsx : <></>
}
export default memo(DetailSoldCars)

DetailSoldCars.propTypes = {
  carId: PropTypes.string
}

DetailSoldCars.defaultProps = {
  carId: ''
}
